
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19.719 5.281l8 8 .688.719-.688.719-8 8-1.438-1.438L24.562 15H10.999c-2.774 0-5 2.226-5 5s2.226 5 5 5v2c-3.854 0-7-3.146-7-7s3.146-7 7-7h13.563l-6.281-6.281z"}})])
          )
        }
      }
    